import { useMemo } from 'react';

import {
  EXTRAS_TAXONOMY_KEY,
  OFFICIANTS_TAXONOMY_KEY,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';

import useCurrentStorefront from '~/components/common/hooks/useCurrentStorefront';
import useVendorUserContext from '~/hooks/vendors/useVendorUserContext';
import experimentFlags from '~/util/experimentFlags';

export const useShowBoostListing = () => {
  const { taxonomyKey } = useCurrentStorefront() || {};
  const { vendorUserContext, loaded } = useVendorUserContext();

  const showBoostListing = useMemo(() => {
    const hideBoostListingLink = experimentFlags.isUnderTest(
      'marketplace-hide-boost-listing-link',
      vendorUserContext,
      false
    );
    const isOfficiantsOrExtras =
      taxonomyKey === OFFICIANTS_TAXONOMY_KEY || taxonomyKey === EXTRAS_TAXONOMY_KEY;
    return loaded && vendorUserContext && !hideBoostListingLink && !isOfficiantsOrExtras;
  }, [loaded, taxonomyKey, vendorUserContext]);

  return {
    loaded,
    showBoostListing,
  };
};
